<template>
  <div class="space-y-6">

    <div v-if="form && chosenClient" class="flex justify-end">
      <button type="submit"
              @click="handleStatusClick()"
              :class="[ { 'bg-red-500' : form.is_active }, { 'bg-green-400' : !form.is_active }, 'ml-3 inline-flex justify-center py-2 px-4 border shadow-sm text-sm font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2']">
        {{ form.is_active ? 'Disable' : 'Enable' }}
      </button>
      <button type="submit"
              @click="handleApproveRegistersPermission()"
              :class="[ { 'bg-red-500' : form.can_approve_registers }, { 'bg-green-400' : !form.can_approve_registers }, 'ml-3 inline-flex justify-center py-2 px-4 border shadow-sm text-sm font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2']">
        {{
          form.can_approve_registers ? 'Turn off register acceptance permission' : 'Turn on register acceptance permission'
        }}
      </button>
      <button type="submit"
              @click="handleDeleteClick()"
              class="bg-red-500 ml-3 inline-flex justify-center py-2 px-4 border shadow-sm text-sm font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2">
        Delete from organisation
      </button>
    </div>

    <div class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
      <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
          <h3 class="text-lg font-medium leading-6 text-gray-900">Permissions</h3>
          <p class="mt-1 text-sm text-gray-500">
            Here you'll find permissions for the user
          </p>
        </div>

        <div v-if="!isLoading" class="mt-5 md:mt-0 col-span-2">

          <div v-if="this.portfolio_id" class="grid md:grid-cols-2 md:gap-2">

            <div class="col-span-2">
              <input-field type="date"
                           label="Expiry Date"
                           name="expiry_date"
                           :errors="errors?.expiry_date"
                           v-model="form.expiry_date"/>


            </div>
            <div class="col-span-2">
              <div class="flex items-center">
                <input v-model="form.can_approve_registers" id="can_approve_registers" name="can_approve_registers"
                       type="checkbox"
                       class="h-4 w-4 text-uknar-secondary focus:ring-uknar-secondary border-gray-300 rounded">
                <label for="can_approve_registers" class="ml-2 block text-sm text-gray-900">
                  Can accept registers
                </label>
              </div>
            </div>
          </div>

          <div v-if="!clientId && !portfolio_id" class="col-span-2">
            <v-select-field label="Choose organisation"
                            name="client"
                            :options="clients"
                            option-label="name"
                            @input="handleClientInput"
                            :errors="errors?.client ?? []"
                            v-model="chosenClient"/>
          </div>

          <template v-if="chosenClient">
            <div class="grid grid-cols-2 gap-3 mt-4">
              <div class="md:col-span-1 col-span-2" :key="rolesSelectKey">
                <v-select-field label="Role"
                                name="roles"
                                multiple
                                required
                                :options="roles"
                                option-label="name"
                                :transform="o => o.id"
                                :errors="errors?.roles ?? []"
                                v-model="form.roles"/>
              </div>
              <div class="md:col-span-1 col-span-2">
                <input-field type="date"
                             label="Expiry Date"
                             name="expiry_date"
                             :errors="errors?.expiry_date"
                             v-model="form.expiry_date"/>
              </div>
            </div>

            <template v-if="clients">
              <div class="font-bold border-b mt-4 mb-3 pb-3">
                Select properties <span class="text-red-600 text-xs">*</span>
                <p v-if="errors?.properties" class="text-red-500 text-xs italic font-normal">
                  <div v-for="error of errors.properties">{{ error }}</div>
                </p>

                <div class="flex items-center mt-3">
                  <input @change="handleCheckAll($event)" id="check_all" type="checkbox"
                         class="h-4 w-4 text-uknar-secondary focus:ring-uknar-secondary border-gray-300 rounded">
                  <label for="check_all" class="ml-2 block text-sm text-gray-900">
                    All properties within portfolio
                  </label>
                </div>
              </div>

              <template v-if="chosenClient">
                <div>
                  <div class="flex items-center">
                    <input @change="handleCheckAllWithin($event, chosenClient)" v-model="checkedClients"
                           name="clients[]" :value="chosenClient.id" :id="'check_all_within' + chosenClient.id"
                           type="checkbox"
                           class="h-4 w-4 text-uknar-secondary focus:ring-uknar-secondary border-gray-300 rounded">
                    <label :for="'check_all_within' + chosenClient.id" class="ml-2 block text-sm text-gray-900">
                      All properties within "{{ chosenClient.name }}"
                    </label>
                  </div>

                  <div class="ml-5" v-for="property of chosenClient.properties">
                    <div class="flex items-center">
                      <input :id="'property_' + property.id" v-model="form.properties" :value="property.id"
                             name="properties[]" type="checkbox"
                             class="h-4 w-4 text-uknar-secondary focus:ring-uknar-secondary border-gray-300 rounded">
                      <label :for="'property_' + property.id" class="ml-2 block text-sm text-gray-900">
                        {{ property.name ?? 'Unnamed property' }}
                      </label>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div v-for="client of clients">
                  <div class="flex items-center">
                    <input @change="handleCheckAllWithin($event, client)" v-model="checkedClients" name="clients[]"
                           :value="client.id" :id="'check_all_within' + client.id" type="checkbox"
                           class="h-4 w-4 text-uknar-secondary focus:ring-uknar-secondary border-gray-300 rounded">
                    <label :for="'check_all_within' + client.id" class="ml-2 block text-sm text-gray-900">
                      All properties within "{{ client.name }}"
                    </label>
                  </div>

                  <div class="ml-5" v-for="property of client.properties">
                    <div class="flex items-center">
                      <input :id="'property_' + property.id" v-model="form.properties" :value="property.id"
                             name="properties[]" type="checkbox"
                             class="h-4 w-4 text-uknar-secondary focus:ring-uknar-secondary border-gray-300 rounded">
                      <label :for="'property_' + property.id" class="ml-2 block text-sm text-gray-900">
                        {{ property.name ?? 'Unnamed property' }}
                      </label>
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </template>
        </div>
      </div>
    </div>

    <div v-if="chosenClient || portfolio_id" class="flex justify-end mt-5">
      <a :href="cancelRoute"
         class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-uknar-primary">
        Cancel
      </a>
      <button type="submit"
              @click="handleSaveClick()"
              class="ml-3 inline-flex justify-center py-2 px-4 border border-uknar-primary-dark shadow-sm text-sm font-medium rounded-md text-white bg-uknar-primary hover:bg-uknar-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-uknar-primary">
        Save
      </button>
    </div>

    <session-alert :success="alerts.success" @hide="alerts = { success: null, error:null }"
                   :error="alerts.error" form_error="false"></session-alert>
  </div>
</template>

<script>
import VSelectField from "../components/form/VSelectField";

export default {
  name: "UserPermissionForm",
  components: {VSelectField},
  props: {
    userId: {
      required: true,
      type: Number
    },
    portfolioId: {
      required: false,
      type: Number
    },
    clientId: {
      required: false,
      type: Number
    }
  },

  data() {
    return {
      errors: null,
      form: null,
      isLoading: false,
      chosenClient: null,
      checkedClients: [],
      clients: [],
      portfolio_id: null,
      portfolio_data: [],
      roles: [],
      alerts: {
        success: {message: '',},
        error: {message: ''}
      },
      rolesSelectKey: 1,
    }
  },

  computed: {
    cancelRoute() {
      return window.route('management.user', this.userId);
    }
  },

  mounted() {
    this.form = this.getEmpty();

    this.loadOptions();

    if (this.clientId) {
      this.loadPermissions({id: this.clientId});
    }
  },

  methods: {
    setErrors(error) {
      if (error.response.status === 422) {
        this.errors = error.response.data.errors
      } else {
        this.alerts = {
          success: null,
          error: error.response?.data?.message ?? error.message
        }
      }
    },

    handleCheckAll($event) {
      let properties = [];
      for (const client of this.clients) {
        properties = properties.concat(client.properties.map(o => o.id));
      }

      if ($event.target.checked) {
        this.checkedClients = this.clients.map(o => o.id);
        this.form.properties = properties;
      } else {
        this.checkedClients = [];
        this.form.properties = [];
      }
    },

    handleCheckAllWithin($event, client) {
      if ($event.target.checked) {
        this.form.properties = this.form.properties.concat(client.properties.map(o => o.id));
      } else {
        for (const property of client.properties) {
          const index = this.form.properties.indexOf(property.id);
          if (index > -1) {
            this.form.properties.splice(index, 1);
          }
        }
      }
    },

    displayResponseMessage(response) {
      this.alerts = {
        success: {message: response.data?.success ? response.data?.message : null},
        error: {message: !response.data?.success ? response.data?.message : null}
      }
    },

    handleDeleteClick() {
      axios.delete(route('ajax.users.permissions', [this.userId, this.chosenClient.id]))
          .then(response => {
            window.location.href = this.cancelRoute;
          })
          .catch(error => {
            console.log(error)
          })
    },

    handleApproveRegistersPermission() {
      axios.patch(route('ajax.users.toggle-approve-register', [this.userId, this.chosenClient.id]))
          .then(response => {
            this.form.can_approve_registers = !this.form.can_approve_registers;
            this.displayResponseMessage(response);
          })
          .catch(error => {
            console.log(error);
          })
    },

    handleStatusClick() {
      axios.patch(route('ajax.users.toggle-status', [this.userId, this.chosenClient.id]))
          .then(response => {
            this.form.is_active = !this.form.is_active;
            this.displayResponseMessage(response);
          })
          .catch(error => {
            console.log(error);
          })
    },

    handleSaveClick() {

      if (this.portfolio_id) {
        console.log(this.form);
        //
        axios.post(route('ajax.users.update-portfolio-permissions', [this.userId, this.portfolio_id]), this.form)
            .then(response => {
              this.displayResponseMessage(response);
            })
            .catch(error => {
              this.setErrors(error);
            })
      } else if (this.chosenClient.id) {

        axios.post(route('ajax.users.permissions', [this.userId, this.chosenClient.id]), this.form)
            .then(response => {
              this.displayResponseMessage(response);
            })
            .catch(error => {
              this.setErrors(error);
            })
      }
    },

    handleClientInput(value) {
      this.form = this.getEmpty();
      this.rolesSelectKey++;

      if (value) {
        this.loadPermissions(value);
      }
    },

    getEmpty() {
      return {
        roles: [],
        expiry_date: null,
        can_approve_registers: false,
        properties: [],
        is_active: true,
      }
    },

    loadOptions() {
      this.isLoading = true;
      let url = route('ajax.users.permission-options', this.userId);

      if (this.portfolioId) {
        url += '?portfolio_id=' + this.portfolioId
      }

      if (this.clientId) {
        url += '?client_id=' + this.clientId
      }

      axios.get(url)
          .then(response => {
            this.clients = response.data.data.clients;
            this.roles = response.data.data.roles;

            if(
                response.data.data.hasOwnProperty('portfolio_id')
                && response.data.data.hasOwnProperty('portfolio_data')) {

              this.portfolio_id = response.data.data.portfolio_id;
              this.portfolio_data = response.data.data.portfolio_data;

              this.form = {
                expiry_date: this.portfolio_data.expiry_date,
                can_approve_registers: !!this.portfolio_data.can_approve_registers
              }
            }


            if (this.clientId) {
              this.chosenClient = this.clients.find(o => o.id == this.clientId);
            }
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            this.isLoading = false;
          })
    },

    loadPermissions(client) {
      axios.get(route('ajax.users.permissions', {user: this.userId, client: client.id}))
          .then(response => {
            const permissions = response.data.data.permissions;

            this.form = {
              roles: permissions.roles.map(o => o.id),
              expiry_date: permissions.expiry_date,
              can_approve_registers: !!permissions.can_approve_registers,
              properties: permissions.properties.map(o => o.id),
              is_active: permissions.is_active
            }

            this.rolesSelectKey++;
          })
          .catch(error => {
            console.log(error)
          })
    }
  }
}
</script>
